<template>
  <div class="list">
    <div class="item animate__animated animate__fadeInUp" v-for="item in list" :key="item.id">
      <div class="img">
        <img :src="$baseURL + item.thumb" />
      </div>
      <div class="info">
        <h6 class="dh_text">
          {{ item.title }} <i>{{ item.sub_title }}</i>
        </h6>
        <router-link :to="{ name: 'productInfo', params: { id: item.id } }"
          class="icon-jiantou iconfont">MORE</router-link>
      </div>
    </div>
    <Loading v-show="loading"></Loading>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  grid-row-gap: 50px;
  position: relative;

  .item {
    .img {
      background: #f6f6f8;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        transition: all 0.3s;
      }
    }

    .info {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      h6 {
        width: 70%;
        font-size: 18px;

        i {
          margin-left: 10px;
          font-weight: 400;
        }
      }

      a {
        white-space: nowrap;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        color: var(--themeColor2);
        font-size: 14px;

        &.iconfont {
          font-family: Regular !important;
        }

        &::before {
          font-family: iconfont !important;
          font-size: 12px;
          margin-left: 10px;
        }
      }
    }

    &:hover {
      .img {
        img {
          transform: scale(1.1);
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .list {
    .item {
      .info {
        h6 {
          font-size: 16px;
        }

        a {
          &::before {
            margin-left: 2px;
          }
        }
      }
    }
  }
}

@media (max-width: 900px) {
  .list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .list {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>